import styled, {css} from 'styled-components';
export const Container = styled.div`
    position: relative;
    display: flex;
    width: 480px;
    height: 460px;
    flex-direction: column;
    cursor: default;
    .optionr--{
        display: flex;
        flex: 2;
    }
    ${({loading}) => loading &&     
       css`        
        pointer-events: none;
        opacity: 0.6;
       `
    };
`
export const Tab = styled.div`
   display: flex;
   width: 100%;
   height: 2.5rem;
   background-color: #f6f6f6;
   border-bottom: 1px solid #dee2e6;
    .tabName{
        display: flex;
        width: 8rem;
        height: 100%;
        justify-content: center;
        align-items: center;
        color: #000;
        cursor: pointer;
    }
    .select{
        color: #ffff;
        background-color: #1983e2;
    }
`
export const SelectStatus = styled.div`
   display: flex;
   width: 100%;
   height: 2.5rem;
   background-color: #f6f6f6;
   border-bottom: 1px solid #dee2e6;
   justify-content: space-around;
   align-items: center;

   ${({disabled}) => disabled &&     
       css`        
        pointer-events: none;
        opacity: 0.6;
       `
    };

    span{
        display: flex;
        align-items: center;
        gap: 0.75rem;
        input{
            cursor: pointer;
        }
    }
`
export const Content = styled.div`
    display: flex;
    width: 100%;
    flex:5;
    overflow: hidden;
    flex-direction: column;
    .search--usersAndGroup{
        margin-top: 10px;
    }
`
export const List = styled.ul`
    display: flex;
    margin-top: 0.5rem;
    max-height: 100%;
    flex-direction: column;
    overflow: scroll;
    &::-webkit-scrollbar{
        width: 5px;
        height: 5px;
    }
    &::-webkit-scrollbar-thumb{
        background-color: rgb(0, 0, 0,0.2);
    }
`